import Box from '@mui/material/Box';
import Stack from '@mui/material/Stack';

import StepContainer from './StepContainer';
import StepCopyContainer from './StepCopyContainer';
import StepTwoMessageBubble from './StepTwoMessageBubble';

const StepTwo = () => (
    <StepContainer className="buying-online-steps--step-2">
        <StepCopyContainer
            heading="2. Buy"
            subHeading={<span>Fill in your details from home. We provide remote support along the way.</span>}
        />
        <Stack
            direction={{ xs: 'column', sm: 'row' }}
            useFlexGap
            sx={{
                alignItems: 'center',
                justifyContent: { sm: 'space-between' },
                flex: { lg: '1 0 0' },
            }}
        >
            <Box
                sx={{
                    borderRadius: { xs: 1.5, sm: 3 },
                    width: '100%',
                    height: { xs: '21.375rem', sm: '32.5rem' },
                    backgroundImage: {
                        xs: 'url("/home/images/buying-online/steps/buyonline-buy-sm.jpg")',
                        sm: 'url("/home/images/buying-online/steps/buyonline-buy.jpg")',
                    },
                    backgroundPosition: {
                        sm: '25% center',
                        md: '10% center',
                        lg: '25% center',
                        xl: 'initial',
                    },
                    backgroundSize: 'cover',
                }}
            />
            <Stack
                spacing={{ xs: 1.5, sm: 2 }}
                useFlexGap
                sx={{
                    mt: { xs: -18, sm: 0 },
                    ml: { sm: -28 },
                    px: { xs: 3, sm: 0 },
                    width: { sm: '25rem' },
                    minWidth: { sm: '25rem' },
                }}
            >
                <StepTwoMessageBubble
                    containerClass="buying-online-steps--communication-bubble-1"
                    bubbleDirection="left"
                    avatarAltText="CarMax representative, Jordan"
                    avatarSrcUrl="/home/images/buying-online/steps/buy-jordan.png"
                    messageName="CarMax"
                    messageTime="2:30 PM"
                    messageText="Your financing is all set and is ready for your review"
                />
                <StepTwoMessageBubble
                    containerClass="buying-online-steps--communication-bubble-2"
                    bubbleDirection="right"
                    avatarAltText="CarMax customer, Monique"
                    avatarSrcUrl="/home/images/buying-online/steps/buy-monique.png"
                    messageName="Monique"
                    messageTime="2:35 PM"
                    messageText="Great! Can you also help me get a trade-in offer?"
                />
            </Stack>
        </Stack>
    </StepContainer>
);

export default StepTwo;
